import React, { useState, useEffect } from 'react'
import { Users, Award, Target, Heart } from 'lucide-react'
import useIntersectionObserver from '../hooks/useIntersectionObserver'

function AboutPage() {
  const [heroVisible, setHeroVisible] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  // Animasyon için intersection observer'lar
  const [storyRef, storyVisible] = useIntersectionObserver()
  const [valuesRef, valuesVisible] = useIntersectionObserver()
  const [statsRef, statsVisible] = useIntersectionObserver()

  // Ofis görselleri
  const officeImages = [
    '/foto/ofis1.jpg',
    '/foto/ofis2.jpg',
    '/foto/ofis3.jpg'
  ]

  // Hero section için animasyon
  useEffect(() => {
    const timer = setTimeout(() => {
      setHeroVisible(true)
    }, 300)
    return () => clearTimeout(timer)
  }, [])

  // Görsel değiştirme efekti
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % officeImages.length
      )
    }, 3000) // 3 saniye

    return () => clearInterval(interval)
  }, [officeImages.length])
  const values = [
    {
      icon: Target,
      title: 'Müşteri Odaklılık',
      description: 'Müşterilerimizin ihtiyaçlarını önceleyerek, onlara en uygun çözümleri sunmaya odaklanıyoruz.'
    },
    {
      icon: Award,
      title: 'Profesyonellik',
      description: 'Sektördeki deneyimimiz ve uzman kadromuzla her zaman en yüksek standartları koruyoruz.'
    },
    {
      icon: Heart,
      title: 'Güvenilirlik',
      description: 'Tüm işlemlerimizde şeffaflık ve dürüstlük ilkesiyle hareket eder, güven veririz.'
    },
    {
      icon: Users,
      title: 'Ekip Çalışması',
      description: 'Güçlü ekip ruhumuzla birlikte çalışarak en iyi sonuçları elde ediyoruz.'
    }
  ]

  return (
    <div>
      {/* Hero Section */}
      <section className="relative h-96 flex items-center text-white overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url("/foto/fab1.jpg")'
          }}
        ></div>
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>
        
        {/* Content */}
        <div className="relative container-custom z-10">
          <div className="max-w-4xl">
            
          </div>
        </div>
      </section>

      <div className="py-12 bg-white">
        <div className="container-custom">
          {/* Story Section */}
          <div ref={storyRef} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20 slide-left ${storyVisible ? 'visible' : ''}`}>
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">
                Hikayemiz
              </h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  ORGANİZE GAYRİMENKUL, Gaziantep'in sanayi üssü konumundaki Şehitkamil Organize Sanayi Bölgesi'nde,
                  Fabrika Satışı-Kiralaması ve Fabrika arsası satışı alanında uzmanlaşmış bir emlak firması olarak faaliyet göstermektedir.
                </p>
                <p>
                  Kurucumuz Ali Cansız'ın sektöre olan ilgisi ve bölgeye dair derin bilgi birikimiyle yola çıkan firmamız,
                  işletmelere en uygun sanayi arsalarını sunmak için
                  güvenilir ve sonuç odaklı bir hizmet anlayışıyla çalışmaktadır.
                </p>
                <p>
                  Kuruluşumuzdan bu yana üretim gücünün kalbi olan bu bölgede, sanayicilerimizin doğru lokasyonda, 
                  doğru yatırım kararları almalarına rehberlik ediyoruz. Geniş portföyümüz, yerel piyasa
                  bilgimiz ve güvenilir hizmet anlayışımızla,
                  işletmelerin büyüme yolculuklarında sağlam adımlar atmalarını sağlıyoruz.
                </p>
                <p>
                  Her zaman şeffaflık, güven ve sürdürülebilir iş ilişkileri prensipleriyle
                  çalışıyor; teknoloji destekli çözümlerimizle süreçleri hızlandırıyor ve 
                  müşterilerimize değer katmayı amaçlıyoruz.
                </p>
                <p>
                  Gaziantep sanayisinin geleceğine katkı sağlamak ve işletmelerin yatırım 
                  hedeflerine ulaşmasında yol arkadaşı olmak için buradayız.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="relative overflow-hidden rounded-lg shadow-lg max-w-md mx-auto">
                {officeImages.map((image, index) => (
                  <img 
                    key={index}
                    src={image} 
                    alt={`Ofis görünümü ${index + 1}`}
                    className={`w-full h-auto transition-opacity duration-1000 ${
                      index === currentImageIndex ? 'opacity-100' : 'opacity-0 absolute top-0 left-0'
                    }`}
                  />
                ))}
              </div>
              
              {/* Görsel göstergeleri */}
              <div className="flex justify-center mt-4 space-x-2">
                {officeImages.map((_, index) => (
                  <div
                    key={index}
                    className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                      index === currentImageIndex ? 'bg-primary-600' : 'bg-gray-300'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Values Section */}
          <div ref={valuesRef} className={`mb-20 fade-in ${valuesVisible ? 'visible' : ''}`}>
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Değerlerimiz
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Çalışma prensiplerimizi belirleyen temel değerlerimiz
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, index) => {
                const Icon = value.icon
                return (
                  <div 
                    key={index} 
                    className={`text-center p-6 bg-gray-50 rounded-xl scale-up ${valuesVisible ? 'visible' : ''}`}
                    style={{ transitionDelay: `${index * 0.15}s` }}
                  >
                    <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                      <Icon className="text-primary-600" size={32} />
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                )
              })}
            </div>
          </div>

          {/* Stats Section */}
          <div ref={statsRef} className={`bg-white p-12 text-center border-2 border-primary-600 slide-up ${statsVisible ? 'visible' : ''}`}>
            <h3 className="text-3xl font-thin mb-8 tracking-wide text-gray-800">
              Rakamlarla Başarımız
            </h3>
            <div className="grid grid-cols-3 gap-8">
              <div className="p-6">
                <div className="text-4xl font-thin mb-2 text-primary-700">1000+</div>
                <div className="text-gray-600 font-light">Satılan Emlak</div>
              </div>
              <div className="p-6">
                <div className="text-4xl font-thin mb-2 text-primary-700">500+</div>
                <div className="text-gray-600 font-light">Mutlu Müşteri</div>
              </div>
              <div className="p-6">
                <div className="text-4xl font-thin mb-2 text-primary-700">10+</div>
                <div className="text-gray-600 font-light">Yıl Deneyim</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutPage